export const LOAD_INDICATOR = "LOAD_INDICATOR"
export const FETCH_INDICATOR = "FETCH_INDICATOR"
export const LOAD_INDICATOR_FAIL = "LOAD_INDICATOR_FAIL"

export const POST_INDICATOR = "POST_INDICATOR"
export const POST_INDICATOR_FAIL = "POST_INDICATOR_FAIL"

export const PATCH_INDICATOR = "PATCH_INDICATOR"
export const PATCH_INDICATOR_FAIL = "PATCH_INDICATOR_FAIL"

export const DELETE_INDICATOR = "DELETE_INDICATOR"
export const DELETE_INDICATOR_FAIL = "DELETE_INDICATOR_FAIL"